module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgAQAAAADK40qVAAAAAnRSTlMAAHaTzTgAAAAjSURBVHgBYxiGgP8/EHygNef/fwjn/38SOKOcUQ4d0+goAACm79o0k6UZDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/side-by-side-icon.png
// module id = 56
// module chunks = 0